export default __webpack_public_path__ + "static/media/transfer-icon-home-mobile.37be02b9.webp";